<div class="dialog">
    <div class="dialog_header">      
        <button mat-icon-button class="close"  mat-dialog-close><svg
            xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path id="ic_close"
                d="M213.746-744.393l-6.441,6.436a1.459,1.459,0,0,1-1.063.457,1.406,1.406,0,0,1-1.046-.457,1.418,1.418,0,0,1-.45-1.054,1.449,1.449,0,0,1,.45-1.037l6.441-6.452-6.441-6.452a1.419,1.419,0,0,1-.441-1.037,1.473,1.473,0,0,1,.441-1.053,1.406,1.406,0,0,1,1.046-.457,1.485,1.485,0,0,1,1.063.441l6.441,6.452,6.458-6.452a1.431,1.431,0,0,1,1.046-.441,1.458,1.458,0,0,1,1.063.457,1.443,1.443,0,0,1,.433,1.053,1.448,1.448,0,0,1-.45,1.037l-6.441,6.452,6.441,6.452a1.419,1.419,0,0,1,.441,1.037,1.473,1.473,0,0,1-.441,1.054,1.406,1.406,0,0,1-1.046.457,1.406,1.406,0,0,1-1.046-.457Z"
                transform="translate(-204.746 755.5)" fill="#999" />
        </svg>
    </button>
        {{"rewardedEmployees.Employees"|translate}}
    </div>
    <div class="dialog_content p-0" mat-dialog-content>

        <div class="search">
            <form (ngSubmit)="GetDepartements()">
                <div class="search_input">
                    <a>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15.997" viewBox="0 0 16 15.997">
                            <path id="search"
                                d="M17.754,16.627l-2.966-2.944A7.194,7.194,0,1,0,13.677,14.8l2.942,2.944a.795.795,0,0,0,1.135-1.112ZM9.192,14.8a5.6,5.6,0,1,1,5.6-5.6,5.6,5.6,0,0,1-5.6,5.6Z"
                                transform="translate(-1.979 -1.979)" fill="#666" />
                        </svg>
                    </a>
                    <input [(ngModel)]="search" [ngModelOptions]="{standalone:true}" type="text"
                        [placeholder]="'rewardedEmployees.Search for Employee'|translate">

                    <ng-container *ngIf="search">
                        <a (click)="search = ''; GetDepartements()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15.997" viewBox="0 0 14 14">
                                <path id="ic_close"
                                    d="M211.746-746.861l-5.01,5.006a1.135,1.135,0,0,1-.827.356,1.094,1.094,0,0,1-.814-.356,1.1,1.1,0,0,1-.35-.819,1.127,1.127,0,0,1,.35-.807l5.01-5.018-5.01-5.018a1.1,1.1,0,0,1-.343-.807,1.145,1.145,0,0,1,.343-.819,1.093,1.093,0,0,1,.814-.356,1.155,1.155,0,0,1,.827.343l5.01,5.018,5.023-5.018a1.113,1.113,0,0,1,.814-.343,1.134,1.134,0,0,1,.827.356,1.122,1.122,0,0,1,.337.819,1.127,1.127,0,0,1-.35.807l-5.01,5.018,5.01,5.018a1.1,1.1,0,0,1,.343.807,1.146,1.146,0,0,1-.343.819,1.094,1.094,0,0,1-.814.356,1.094,1.094,0,0,1-.814-.356Z"
                                    transform="translate(-204.746 755.5)" fill="#6b6d85" />
                            </svg>
                        </a>
                    </ng-container>
                </div>
            </form>
        </div>

        <div *ngIf='loadingDepartemtents' class="dataLoading py-5">
            <mat-spinner class="m-auto" diameter="50"></mat-spinner>
        </div>

        <div class="table-responsive table-container" *ngIf='!loadingDepartemtents'>
            <table class="table table-primary w-100 mt-2">
                <thead>
                    <tr>
                        <th>{{"rewardedEmployees.Employee Name"|translate}}</th>
                        <th class="text-right"> {{"rewardedEmployees.Reward points amount"|translate}}</th>
                    </tr>
                </thead>
                <tbody *ngIf="DepartementsList?.length">
                    <ng-container *ngFor="let item of DepartementsList; let i=index">

                        <tr class="title cursor_pointer"
                            *ngIf="item?.num_employees"
                            (click)="showDepartments(i); item?.list_employees?.length ? null : GetEmployees(item?.department_id,i)">
                            <td colspan="2" class="text-center">
                                <span>
                                    {{"rewardedEmployees.Department"|translate}}:
                                </span>
                                {{item?.department_name}} ({{item?.num_employees}})
                            </td>
                        </tr>
                        <ng-container *ngIf="item?.list_employees && !DepartementsList[i].loading && DepartementsList[i].show">
                            <tr *ngFor="let employee of item?.list_employees">
                                <td>
                                    <div class="name-with-image">
                                        <div class="image-circle">
                                            <img *ngIf="employee.logo" [src]="employee.logo"
                                                (error)='employee.logo = ""'>
                                            <span *ngIf="!employee.logo">{{ employee.full_name | shortName }}</span>
                                        </div>
                                        <div class="name">
                                            <h5 class="font-18 fontRegular small-width">
                                                {{employee.full_name}}
                                            </h5>
                                        </div>
                                    </div>
                                </td>

                                <td class="points text-right">{{employee.num_points}} <span
                                        class="font-14">{{"companies.point"|translate}}</span>
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf='DepartementsList[i].loading' style="background-color: transparent !important;">
                            <td colspan="2">
                                <div class="dataLoading">
                                    <mat-spinner class="d-block m-auto" diameter="50"></mat-spinner>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>

            <div *ngIf="!DepartementsList?.length && !loadingDepartemtents" class="no-data">
                <img src="assets/images/no-data.svg" alt="">
                <h4>{{'general.No Data Found' | translate}}</h4>
            </div>

        </div>

    </div>
    <div class="dialog_actions" mat-dialog-actions>
        <button mat-button mat-dialog-close class="btn-secondary">{{"general.close"|translate}}</button>
    </div>
</div>